import { Accessor, useContext } from 'solid-js';
import { TIDContext, TIDContextState } from './TIDContext';

/**
 * This hook will allow you to access all functions and properties available in the TIDProvider
 * Functions and properties available:
 * * handleCallback
 * * getAccessTokenSilently
 * * loginWithRedirect
 * * logout
 * * isAuthenticated
 * * isLoading
 * * user
 * * error
 * @return {TIDContextState}
 */
export const useAuth = (): Accessor<TIDContextState> => {
  const auth = useContext(TIDContext);
  return auth!;
};
